import { render } from "./OrderEditModal.vue?vue&type=template&id=d207c038"
import script from "./OrderEditModal.vue?vue&type=script&lang=js"
export * from "./OrderEditModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\GameToGo\\Desktop\\ecommerce-movie7-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__